import microsoftClarity from "web/script/embedded/microsoft-clarity";

export default {
    init: function () {
        microsoftClarity();
    },

    send: function () {},
};
